export default class Submit {
  constructor(checkbox1, checkbox2, submit) {
    this.checkbox1 = checkbox1;
    this.checkbox2 = checkbox2;
    this.submit = submit;

    this.setup()
  }

  setup () {
    this.checkbox1.addEventListener('change', (event) => {
      if(this.checkbox1.checked && this.checkbox2.checked)
      {
        this.submit.disabled = false;
      }
      else
      {
        this.submit.disabled = true;
      }
    });
    this.checkbox2.addEventListener('change', (event) => {
      if(this.checkbox1.checked && this.checkbox2.checked)
      {
        this.submit.disabled = false;
      }
      else
      {
        this.submit.disabled = true;
      }
    });
  }

}